import { EvsbMailOfferFormModel } from './evsb-mail-offer-form.model';
import { Injectable } from '@angular/core';

@Injectable()
export class EvsbMailOfferFormMapper {
  public getModel(): EvsbMailOfferFormModel {
    return {
      vatNumber: '',
      company: '',
      firstName: '',
      lastName: '',
      telephone: '',
      email: '',
      alreadyClient: false,
      consent: false,
    };
  }
}
